























import {Component, Prop, Vue} from 'vue-property-decorator'
import {Category, IServiceTypePriceReverse} from '@/entities'

@Component
export default class ServiceSelectCard extends Vue {

  @Prop() readonly data!: IServiceTypePriceReverse
  @Prop({ default: false }) readonly selected?: boolean

  get price(): string {
    return this.$storage.getters.getPriceLabel(this.data.price);
  }

  get category(): Category | undefined {
    return this.data.category;
  }

  get title(): string {
    const category = this.category;
    return category ?
      this.$options.filters?.capitalize(this.$t(`category.${category}`)) :
      this.data.service_type.name;
  }

  get description(): string | undefined {
    const category = this.category;
    return category ? (this.$t('categories.' + category + '.description') as string) : this.data.service_type.description;
  }

}
